/** Canonical business states. `abierto` is a read-only legacy alias. */
export const COMMITMENT_STATES = Object.freeze(['pendiente', 'reprogramado', 'completado', 'cancelado'])
export const normalizeCommitmentState = (state) => (state === 'abierto' ? 'pendiente' : state)
export const isOpenCommitment = (state) => ['pendiente', 'reprogramado'].includes(normalizeCommitmentState(state))
export const isTerminalCommitment = (state) => ['completado', 'cancelado'].includes(normalizeCommitmentState(state))
export const normalizeCommitment = (item) => ({ ...item, estado: normalizeCommitmentState(item.estado) })
export const toTodoStatus = (state) => (isTerminalCommitment(state) ? 'completed' : 'notStarted')
